module.exports = __webpack_public_path__ + "static/washer-0d74e672edadb5429366e77ff53b8537.jpg";